import { createContext, FC, useContext } from 'react';
// Import Enums
import { PageTypesEnum } from 'enums';

interface PageModeContextProps {
    pageMode: Nullable<PageTypesEnum>;
}

const PageModeContext = createContext<PageModeContextProps>({
    pageMode: null,
});

export const PageModeProvider: FC<Partial<PageModeContextProps>> = ({ children, pageMode = null }) => {
    return <PageModeContext.Provider value={{ pageMode }}>{children}</PageModeContext.Provider>;
};

export const usePageMode = () => {
    const context = useContext(PageModeContext);
    if (!context) throw new Error('usePageMode must be used within a PageModeProvider');
    return context;
};
